import ButtonInput from '@/components/ui/ButtonInput'
import DocumentsInput from '@/components/forms/DocumentsInput'
import DropdownInput from '@/components/ui/DropdownInput'
import FormActions from '@/components/forms/FormActions'
import FormFieldSet from '@/components/forms/FormFieldSet'
import FormWrap from '@/components/forms/FormWrap'
import RadioBarInput from '@/components/forms/RadioBarInput'
import SelectInput from '@/components/forms/SelectInput'
import GroupedSelectInput from '@/components/forms/GroupedSelectInput'
import SwitchInput from '@/components/forms/SwitchInput'
import TagsInput from '@/components/forms/TagsInput'
import TextAreaInput from '@/components/forms/TextAreaInput'
import TextInput from '@/components/forms/TextInput'
import TagSelect from '@/components/forms/TagSelect'
import EditorInput from '@/components/forms/EditorInput'
import FileInput from '@/components/forms/FileInput'
import SearchInput from '@/components/forms/SearchInput'

export default {
  components: {
    ButtonInput,
    DocumentsInput,
    DropdownInput,
    FormActions,
    FormFieldSet,
    FormWrap,
    RadioBarInput,
    SelectInput,
    GroupedSelectInput,
    SwitchInput,
    TagsInput,
    TextAreaInput,
    TextInput,
    TagSelect,
    EditorInput,
    FileInput,
    SearchInput
  }
}



// WEBPACK FOOTER //
// ./src/mixins/forms/Form.js